import { SxProps, Theme } from '@mui/material';
import { DUTIES_COLOURS } from './theme';

// ============================================================================
// Tab Container Styles
// ============================================================================

/**
 * Tab container wrapper
 * Provides bottom border for tab bar
 */
export const tabContainerStyles: SxProps<Theme> = {
  borderBottom: 1,
  borderColor: 'divider',
  mb: 2
};

// ============================================================================
// Tabs Component Styles
// ============================================================================

/**
 * Main Tabs component styling
 * Handles responsive behaviour and scrolling
 */
export const tabsStyles: SxProps<Theme> = {
  minHeight: '40px',
  '& .MuiTab-root': {
    minHeight: '40px',
    textTransform: 'none',
    fontWeight: 400,
    fontSize: '15px',
    color: DUTIES_COLOURS.primary,
    '&.Mui-selected': {
      fontWeight: 600,
      color: DUTIES_COLOURS.primary
    },
    '@media (max-width: 600px)': {
      minWidth: '48px',
      padding: '8px 12px',
      fontSize: '14px'
    }
  },
  '& .MuiTabs-scrollButtons': {
    color: DUTIES_COLOURS.secondary,
    '&.Mui-disabled': {
      opacity: 0.3,
      color: DUTIES_COLOURS.scrollButtonDisabled
    }
  },
  '& .MuiTabs-indicator': {
    backgroundColor: 'primary.main'
  }
};
